import React, { useEffect, useState, useCallback } from 'react'
import { motion } from 'framer-motion'
import { useSelector, useDispatch } from 'react-redux'
import { CircularProgress, Icon } from '@material-ui/core'
import { Formik, Field, Form } from 'formik'
import { toast } from 'react-toastify'

import Container, { RowButton, DocumentModal, ResultModal } from './styles'
import {
  Table,
  TableContainer,
  TextInput,
  Pagination,
  Icons,
  Title,
  SearchBar,
  Button
} from '@valid/components'
import { fetch } from 'store/reducers/dashboard'
import { maskCpfCnpj } from '@valid/config'
import { get } from 'service/api'
import { avatar } from 'assets/default_avatar.jpg'

export default function () {
  const { token } = useSelector((state) => state.token)
  const { level } = useSelector((state) => state.user)
  const dashboard = useSelector((state) => state.dashboard)
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)
  const [name, setName] = useState('')
  const [cpf, setCpf] = useState('')
  const [docModalOpen, setDocModalOpen] = useState(false)
  const [resModalOpen, setResModalOpen] = useState(false)
  const [modalLoading, setModalLoading] = useState(false)
  const [documentUrl, setDocumentUrl] = useState('')
  const [result, setResult] = useState('')
  const [buscaData] = useState({busca: ''})

  const { list, pages, loading } = dashboard

  const handleFetchPage = useCallback(
    async (number, searchName, searchCpf) => {
      if (token) {
        dispatch(fetch({ 
          token, 
          page: number, 
          name: searchName, 
          cpf: searchCpf 
        }))
      }
    },
    [dispatch, token],
  )

  useEffect(() => {
    handleFetchPage(page, name, cpf)
  }, [handleFetchPage, page, name, cpf])

   async function handleSearch(value) {
     
      setName(value)
      setCpf(value)
      handleFetchPage(page, name, cpf)
  }

  function handlePageChange(_, number) {
    setPage(number)
  }

  function callPrint() {
    window.print();
  }

  function returnColorComponent(color) {
    if (color === "green") return <Icons icon="check" />
    else if (color === "yellow") return <Icons icon="info" />
    else if (color === "red") return <Icons icon="error" />
    else return null
  }

  async function fetchResultData(id) {
    setModalLoading(true)

    const res = await get({
      url: `/dashboard/registers/${id}`,
      token,
    })

    setModalLoading(false)
    if (res.status === 200) {
      setResult(res.data)
    }
  }

  function handleOpenModal(type, id, side) {
    if (type === 'sms') {
      setDocModalOpen(true)

    } else if (type === 'res') {
      setResModalOpen(true)
    }
  }

  function handleCloseModal() {
    setDocModalOpen(false)
    setResModalOpen(false)
  }

  return (
    <Container>
      <motion.div
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.4 }}
      >
        <Title>Dashboard</Title>
      </motion.div>

    <div class="search">
      <SearchBar 
          placeholder="Pesquisar"
          onSearch={(e) => handleSearch(e)}
      />
    </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <TableContainer>
          <Table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>Documento</th>
                <th>Data cadastro</th>
                {level == 'admin' && <th>SMS</th>}
                {level == 'admin' && <th>E-Mail</th>}
                {level == 'admin' && <th>Quiz</th>}
                <th>Resultado</th>
              </tr>
            </thead>
            <tbody>
              {list.length === 0 &&
                <tr key={"-1"}>
                  <td colSpan={8}>Nenhum registro encontrado.</td>
                </tr>
              }
              {list.map((item) => (
                <tr key={item._id}>
                  <td>{item._id}</td>
                  <td>{item.name}</td>
                  <td>
                    {returnColorComponent(item.document.valid)}
                    {maskCpfCnpj(item.document.document)}
                  </td>
                  <td>{item.date_request}</td>
                  {level == 'admin' && <><td>
                    <div className="row center">
                      {item.sms.sms_sent && (
                        <RowButton
                        >
                          {returnColorComponent(item.sms.sms_sent)}
                          <span>Enviado</span>
                        </RowButton>
                      )}
                      {item.sms.sms_valid && (
                        <RowButton
                        >
                          {returnColorComponent(item.sms.sms_valid)}
                          <span>Confirmado</span>
                        </RowButton>
                      )}
                    </div>
                  </td>
                    <td>
                      <div className="row center">
                        {item.email.email_sent && (
                          <RowButton
                          >
                            {returnColorComponent(item.email.email_sent)}
                            <span>Enviado</span>
                          </RowButton>
                        )}
                        {item.email.email_valid && (
                          <RowButton
                          >
                            {returnColorComponent(item.email.email_valid)}
                            <span>Confirmado</span>
                          </RowButton>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="row center">
                        {item.quiz.quiz_started && (
                          <RowButton
                          >
                            {returnColorComponent(item.quiz.quiz_started)}
                            <span>Iniciado</span>
                          </RowButton>
                        )}
                        {item.quiz.quiz_finished && (
                          <RowButton
                          >
                            {returnColorComponent(item.quiz.quiz_finished)}
                            <span>Finalizado</span>
                          </RowButton>
                        )}
                      </div>
                    </td>
                  </>}
                  <td className="centery">
                    <RowButton
                    >
                      {returnColorComponent(item.result)}
                    </RowButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableContainer>

        <Pagination pages={pages} onChange={handlePageChange} />
      </motion.div>

      <DocumentModal open={docModalOpen} onClose={handleCloseModal}>
        {modalLoading && (
          <div className="modal_loading">
            <CircularProgress />
          </div>
        )}
        {!modalLoading && (
          <img src={documentUrl} alt="" className="modal_document" />
        )}
      </DocumentModal>

      <ResultModal open={resModalOpen} onClose={handleCloseModal}>
        {modalLoading && (
          <div className="modal_loading">
            <CircularProgress />
          </div>
        )}
        {!modalLoading && result && (
          <div className="body">
            <div className="left-section">
              <img
                className="image"
                src={result.profile_picture ? result.profile_picture : avatar}
                alt=""
              />
            </div>
            <div className="right-section">
              <p className="name">{result.name}</p>

              <p className="checklist-title">Checklist</p>
              {result.description &&
                result.description.length > 0 &&
                result.description.map((item, i) => (
                  <div className="checklist-item" key={i}>
                    <b>{item.title}</b>
                    <span>{item.value}</span>
                    {item.color && returnColorComponent(item.color)}
                  </div>
                ))}
            </div>
          </div>
        )}
      </ResultModal>

      <div className="float-right-position">
        <Button
          variant="primary"
          onClick={callPrint}>
          Imprimir
        </Button>
      </div>

      {loading && (
        <div className="loading">
          <div className="loading__container">
            <CircularProgress />
          </div>
        </div>
      )}
    </Container>
  )
}
